module.exports = __webpack_public_path__ + "img/delete-list-item.bfdda09a.svg";